export default {
  GET_TRANSACTIONS: state => state.transactions,
  GET_TRANSACTIONS_COUNT: state => state.transactionsCoutn,
  // GET_TRANSACTIONS: state => state.transactions,
  // GET_TRANSACTIONS_COUNT: state => state.transactionsCoutn,
  getTransactionIncomeType: state => state.transaction_income_type,
  getTransactionCashbox: state => state.transaction_cashbox,
  GET_TRANSACTIONS_INCOME_CHARTS: state => state.transactionsIncomeCharts,
  GET_TRANSACTIONS_INCOME_CHARTS_COUNT: state => state.transactionsIncomeChartsCount,
}
